import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';

@Component({
  selector: 'app-features-section',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss'],
  imports: [CommonModule, ToHtmlPipe],
})
 export class FeaturesSectionComponent implements OnInit, OnChanges {
  @Input() pageData:any;
  hasInside = false;
  featuresData: any;

  private updateFeaturesData(): void {
    const data = this.pageData?.features?.[0]?.fields;
    this.hasInside = !this.pageData?.whitepaperAndReportsArticle;
    if (data) {
      this.featuresData = data;
    }
  }

  ngOnInit(): void {
    this.updateFeaturesData();
  }
  ngOnChanges(): void {
    this.updateFeaturesData();
  }
}
